<template>
  <div id="all_list">
    <div class="list_con relativeItem">
      <img
        class="imgBlock noevents-img"
        src="../../assets/xiangshui/xiangshui(11).png"
      />
      <div class="ctr_con">
        <div class="tbtn_div absoluteItem centerImg flex-box">
          <div
            :class="['btn_al', 'btn_lft', { btn_ac: btnIdx == 0 }]"
            @click="btnClick(0)"
          >
            主播榜
          </div>
          <div
            :class="['btn_al', 'btn_rgt', { btn_ac: btnIdx == 1 }]"
            @click="btnClick(1)"
          >
            用户榜
          </div>
        </div>
        <div v-show="!showNo">
          <!-- 前三名的展示 -->
          <div class="three absoluteItem" v-if="listData.length > 2">
            <ul class="flex-box">
              <li>
                <div class="img relativeItem n2">
                  <img
                    src="../../assets/zq (8).png"
                    class="head imgBlock noevents-img"
                    v-if="!listData[1]"
                  />
                  <img
                    :src="listData[1].heade_portrait"
                    class="head imgBlock noevents-img"
                    onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    v-else
                  />
                  <img
                    src="../../assets/rank (2).png"
                    class="imgBlock rank noevents-img absoluteItem"
                  />
                </div>
                <p class="p1 apostrophe">{{ listData[1].nick_name }}</p>
                <p class="p2">
                  精力值 <br />
                  {{ listData[1].total_energy }}
                </p>
              </li>
              <li>
                <div class="img relativeItem n1">
                  <img
                    src="../../assets/zq (7).png"
                    class="head imgBlock noevents-img"
                    v-if="!listData[0]"
                  />
                  <img
                    :src="listData[0].heade_portrait"
                    class="head imgBlock noevents-img"
                    onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    v-else
                  />
                  <img
                    src="../../assets/rank (1).png"
                    class="imgBlock rank noevents-img absoluteItem"
                  />
                </div>
                <p class="p1 apostrophe">{{ listData[0].nick_name }}</p>
                <p class="p2">
                  精力值 <br />
                  {{ listData[0].total_energy }}
                </p>
              </li>
              <li>
                <div class="img relativeItem n3">
                  <img
                    src="../../assets/zq (9).png"
                    class="head imgBlock noevents-img"
                    v-if="!listData[2]"
                  />
                  <img
                    :src="listData[2].heade_portrait"
                    class="head imgBlock noevents-img"
                    onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    v-else
                  />
                  <img
                    src="../../assets/rank (3).png"
                    class="imgBlock rank noevents-img absoluteItem"
                  />
                </div>
                <p class="p1 apostrophe">{{ listData[2].nick_name }}</p>
                <p class="p2">
                  精力值 <br />
                  {{ listData[2].total_energy }}
                </p>
              </li>
            </ul>
          </div>

          <div
            :class="[
              { ab_main: listData.length < 3 },
              { absoluteItem: listData.length < 3 },
            ]"
          >
            <div class="tit_line">
              <ul class="flex-box">
                <li class="flex-box">
                  <p class="pai">排名</p>
                  <p>{{ titRole }}名称</p>
                </li>
                <li>精力值</li>
              </ul>
            </div>
            <div class="zi_list" v-show="listData.length > 0">
              <div id="zuCom">
                <ul class="ul_main">
                  <li
                    class="flex-box lis relativeItem"
                    v-for="(n, i) in listData"
                    :key="i"
                  >
                    <div class="flex-box li_div">
                      <div class="pai_con flex-box">
                        <img
                          class="imgBlock noevents-img"
                          v-if="i == 0"
                          src="../../assets/zxb (5).png"
                        />
                        <img
                          class="imgBlock noevents-img"
                          v-else-if="i == 1"
                          src="../../assets/zxb (6).png"
                        />
                        <img
                          class="imgBlock noevents-img"
                          v-else-if="i == 2"
                          src="../../assets/zxb (7).png"
                        />
                        <p v-else-if="i == 9">{{ i + 1 }}</p>
                        <p v-else>0{{ i + 1 }}</p>
                      </div>
                      <div class="flex-box u_info">
                        <div class="u_avt">
                          <img
                            class="imgBlock noevents-img"
                            :src="n.heade_portrait"
                            onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                          />
                        </div>
                        <div
                          class="u_name apostrophe"
                          v-if="n.nick_name != 'undefined'"
                        >
                          {{ n.nick_name }}
                        </div>
                      </div>
                    </div>

                    <div class="flex-box rgt_box">
                      <div class="flex-box">
                        <i >已{{ listText }}</i>
                      </div>
                      <p class="p2">{{ n.total_energy }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 暂无数据的显示 -->
        <div class="no_data" v-show="showNo">
          <img
            class="imgBlock noevents-img"
            src="../../assets/xiangshui/xiangshui(8).png"
          />
        </div>
      </div>
      <img
        class="imgBlock noevents-img bot_img relativeItem"
        src="../../assets/xiangshui/xiangshui(13).png"
      />
    </div>
    <div class="bot_colo"></div>
  </div>
</template>





<script>

export default {
  props: ["isAnchor", "btnIdx", "listData", "showNo", "titRole", "listText"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 按钮的点击
    btnClick(idx) {
      this.$emit("btnChange", idx); //通知父组件改变。
    },
  },
};
</script>





<style scoped>
.ctr_con {
  min-height: 400px;
  background: url("../../assets/xiangshui/xiangshui(12).png") repeat;
  background-size: 100% 100%;
}

.tbtn_div {
  top: 2.5rem;
  background-color: #dd6867;
  border-radius: 1rem;
  z-index: 18;
}
.btn_al {
  width: 5.625rem;
  height: 2.0625rem;
  line-height: 2.0625rem;
  text-align: center;
  color: #fdf6f5;
  font-size: 0.875rem;
}
.tbtn_div .btn_ac {
  background-color: #ffe5dc;
  color: #ff7776;
}
.btn_lft {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.btn_rgt {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.no_data {
  padding-top: 50px;
}
.no_data img {
  width: 75%;
  margin: auto;
}

/* 榜单样式前三名 */

.three {
  width: 100%;
  top: 120px;
  margin-top: -30px;
}
.three ul {
  padding: 0 10%;
  justify-content: space-between;
  align-items: flex-end;
}
.three li {
  width: 31%;
}
.three .img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 8px;
  border-radius: 50%;
}
.three .n1 {
  width: 73px;
  height: 73px;
}
.three .head {
  border-radius: 50%;
  height: 100%;
}
.three .n1 {
  border: 5px solid #ffca3b;
}
.three .n2 {
  border: 5px solid #b8c1cc;
}
.three .n3 {
  border: 5px solid #ee7e57;
}
.three p {
  text-align: center;
}
.three .p1 {
  color: #ffffff;
  font-size: 15px;
  margin-bottom: 3px;
}
.three .p2 {
  font-size: 12px;
  color: #fee7e8;
  border-radius: 3rem;
  padding: 4px;
  background: #fda1a2;
}
.three .rank {
  width: 60%;
  top: -17px;
  left: -8px;
}
.three .n1 .rank {
  top: -20px;
}

.tit_line {
  padding: 110px 12% 0;
  color: #fff;
  font-size: 0.875rem;
  font-weight: bold;
}
.tit_line ul {
  justify-content: space-between;
  padding-right: 12px;
}
.tit_line .pai {
  margin-right: 36px;
}
.zi_list {
  padding: 12px 10% 0;
}
.ab_main {
  width: 100%;
  top: -2%;
  left: 50%;
  transform: translateX(-50%);
}

.ul_main .pai_con {
  width: 40px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  align-items: center;
  justify-content: center;
}
.pai_con img {
  width: 22px;
}
.lis {
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  z-index: 2;
}
.lis:nth-child(even) {
  background-color: #fda1a2;
}
.li_div {
  align-items: center;
}
.u_info {
  align-items: center;
  margin-left: 20px;
}
.u_info .u_avt {
  width: 1.875rem;
  height: 1.875rem;
}
.u_info .u_name {
  width: 85px;
  margin-left: 12px;
  color: #fff;
  font-size: 0.8125rem;
}
.u_avt img {
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
}
.rgt_box {
  width: 35%;
  align-items: center;
  color: #fee1e2;
  font-size: 0.8125rem;
}
.rgt_box .p2 {
  color: #fee1e2;
  font-size: 0.875rem;
  padding-top: 2px;
  margin-left: 3px;
}
.ul_main li:nth-child(2n) {
  border-radius: 2rem;
}
i {
  font-style: normal;
}
</style>